<template>
    <patternlib-checkbox-v1 style="margin-bottom: var(--spacing-6);" ref="acceptStatement" :status="checkboxStatus">
        <p v-html="$t('legalTexts.default.privacyPolicyAndTermsOfUse', {
            'beginPrivacyPolicy': '<a name=\x22privacyPolicy\x22><u>',
            'beginTermsOfUse': '<a id=\x22termsOfUse\x22><u>',
            'end': '</u></a>'
        })"></p>
    </patternlib-checkbox-v1>

    <patternlib-checkbox-v1 style="margin-bottom: var(--spacing-6);" ref="additionalAgreement" :status="checkboxStatus">
        <p v-html="$t('legalTexts.sg.additionalAgreement', {
            'beginPrivacyPolicy': '<a name=\x22privacyPolicy\x22><u>',
            'end': '</u></a>'
        })"></p>
    </patternlib-checkbox-v1>

    <patternlib-modal 
            :modal-title="$t('legalTexts.privacyPolicy')"
            hide-cancel="true"
            :confirm-label="$t('legalTexts.close')"
            confirm-type="secondary"
            :show="showPrivacyPolicy"
            @lhClose="showPrivacyPolicy=false"
            @lhConfirm="showPrivacyPolicy=false"
        >
            <div slot="modal-content" v-html="privacyPolicy"></div>
        </patternlib-modal>

        <patternlib-modal 
            :modal-title="$t('legalTexts.termsOfUse')"
            hide-cancel="true"
            :confirm-label="$t('legalTexts.close')"
            confirm-type="secondary"
            :show="showTerms"
            @lhClose="showTerms=false"
            @lhConfirm="showTerms=false"
        >
            <div slot="modal-content" v-html="termsOfUse"></div>
        </patternlib-modal>
</template>

<script>
import { useServices } from '../../services/useServices'
import { useGlobal } from '../../stores/globalStore'

export default {
    data: () => ({
        termsOfUse: "Loading...",
        privacyPolicy: "Loading...",
        showPrivacyPolicy: false,
        showTerms: false
    }),

    methods: {
        accept() {
            if (!this.$refs.acceptStatement.checked || !this.$refs.additionalAgreement.checked) {
                this.checkboxStatus = "error"
                return false
            }
            const services = useServices()
            services.$api.acceptDocuments((successful) => {}, this.documentIds)
            return true
        }
    },

    mounted() {
        document.getElementById("termsOfUse").addEventListener("click", () => this.showTerms = true)
        let elements = document.getElementsByName("privacyPolicy")
        elements.forEach((element) => {
            element.addEventListener("click", () => this.showPrivacyPolicy = true)
        })

        const services = useServices()
        const globalStore = useGlobal()

        services.$api.getDocuments((legalTexts) => {
            for (let legalText of legalTexts) {
                if (legalText.typeName == "terms") {
                    this.termsOfUse = legalText.html
                }
                if (legalText.typeName == "privacy") {
                    this.privacyPolicy = legalText.html
                }
            }
        }, "privacy,terms", globalStore.language, globalStore.country)
    }
}
</script>

<style lang="scss" scoped>

</style>